export default {
    contentModule: {
        textAlign: 'end',
    },
    removeGap: {
        marginTop: '-20px',
        paddingTop: '4px',
    },
}